var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-record-audio',{attrs:{"mode":"press"},on:{"result":_vm.onResult}})}
var staticRenderFns = []

export { render, staticRenderFns }